import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getOffersHistorySpoiler } from '../../../../actions/offersHistory';
import { ESpoilerCategoryRequest } from '../../../../store/offerHistory';

export const useActiveCategory = () => {
  const dispatch = useDispatch();

  const [selectedCategory, setSelectedCategory] = useState<ESpoilerCategoryRequest>();

  const updateActiveCategory = useCallback(
    (category: ESpoilerCategoryRequest) => {
      if (selectedCategory === category) {
        return;
      }

      setSelectedCategory(category);

      dispatch(getOffersHistorySpoiler(category));
    },
    [dispatch, selectedCategory],
  );

  return [selectedCategory, updateActiveCategory] as const;
};
